<template >
  <splash></splash>
  <div class="container mt-4" dir="rtl">

    <sidebar></sidebar>
    <div style="    position: absolute;
    right: 28vw;
    width: 51vw; height: auto;" class="card-panel-main col-lg-9 mb-5">
      <div class="card card-body card-panel-box border-0" style="    margin: 1vw .9vw;">
        <center>
          <div class="d-flex justify-content-between align-items-center line_after">

          <p style="font-size: 1.5vw; ">
            ماتریس ارتباطات بیرونی/{{$route.params.title}}
          </p>
            <button style="transform: translateX(3vw); width: 8vw !important;" class="btn btn-primary btn-submit-1" @click="$router.go(-1)">برگشت</button>

          </div>
          <hr>
          <br>
        </center>

        <div class="row">
          <div class="d-flex flex-column col-6">
              <div class="card p-4 w-100">
                <center>
                  <p style="font-weight: bold; font-size: 1.3vw;">ارتباط ذی نفع - فرآیند در سطح طبقه</p>

                  <br>
                  <router-link class="btn btn-submit-1 btn-info w-100" :to="`/Matrix_Connections/exit/by/1/${$route.params.id}/${$route.params.title}`">تکمیل اطلاعات / بروزرسانی</router-link>
                </center>
              </div>
            <br>

              <div class="card p-4 w-100 ">
                <center>
                  <p style="font-weight: bold; font-size: 1.3vw;">ارتباط ذی نفع - فرآیند در سطح گروه</p>
                  <br>
                  <router-link class="btn btn-submit-1 btn-info w-100" :to="`/Matrix_Connections/exit/by/2/${$route.params.id}/${$route.params.title}`">تکمیل اطلاعات / بروزرسانی</router-link>
                </center>
              </div>
            <br>
              <div class="card p-4 w-100">
                <center>
                  <p style="font-weight: bold; font-size: 1.3vw;">ارتباط ذی نفع - فرآیند در سطح فرآیند</p>
                  <br>
                  <router-link class="btn btn-submit-1 btn-info w-100" :to="`/Matrix_Connections/exit/by/3/${$route.params.id}/${$route.params.title}`">تکمیل اطلاعات / بروزرسانی</router-link>
                </center>
              </div>
            <br>

              <div class="card p-4 w-100 ">
                <center>
                  <p style="font-weight: bold; font-size: 1.3vw;">ارتباط ذی نفع - فرآیند در سطح زیر فرآیند</p>
                  <br>
                  <router-link class="btn btn-submit-1 btn-info w-100" :to="`/Matrix_Connections/exit/by/4/${$route.params.id}/${$route.params.title}`">تکمیل اطلاعات / بروزرسانی</router-link>
                </center>
              </div>
          </div>

            <div class="d-flex flex-column col-6">

              <div class="card p-4 w-100">
                <center>
                  <p style="font-weight: bold; font-size: 1.3vw;">ارتباط فرآیند-ذی نفع در سطح طبقه</p>

                  <br>
                  <router-link class="btn btn-submit-1 btn-info w-100" :to="`/Matrix_Connections/exit/by/5/${$route.params.id}/${$route.params.title}`">تکمیل اطلاعات / بروزرسانی</router-link>
                </center>
              </div>
            <br>

              <div class="card p-4 w-100 ">
                <center>
                  <p style="font-weight: bold; font-size: 1.3vw;">ارتباط فرآیند-ذی نفع در سطح گروه</p>
                  <br>
                  <router-link class="btn btn-submit-1 btn-info w-100" :to="`/Matrix_Connections/exit/by/6/${$route.params.id}/${$route.params.title}`">تکمیل اطلاعات / بروزرسانی</router-link>
                </center>
              </div>
            <br>

              <div class="card p-4 w-100">
                <center>
                  <p style="font-weight: bold; font-size: 1.3vw;">ارتباط فرآیند-ذی نفع در سطح فرآیند</p>
                  <br>
                  <router-link class="btn btn-submit-1 btn-info w-100" :to="`/Matrix_Connections/exit/by/7/${$route.params.id}/${$route.params.title}`">تکمیل اطلاعات / بروزرسانی</router-link>
                </center>
              </div>
              <br>

              <div class="card p-4 w-100 ">
                <center>
                  <p style="font-weight: bold; font-size: 1.3vw;">ارتباط فرآیند-ذی نفع در سطح زیر فرآیند</p>
                  <br>
                  <router-link class="btn btn-submit-1 btn-info w-100" :to="`/Matrix_Connections/exit/by/8/${$route.params.id}/${$route.params.title}`">تکمیل اطلاعات / بروزرسانی</router-link>
                </center>
              </div>
            </div>


        </div>




      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Sidebar from "@/components/Sidebar/Sidebar";
import splash from "@/components/Splash/Splash";
import router from "@/router";

export default {
  name: 'HomeView',
  components: {
    Sidebar,
    splash
  },
  methods:{
    checkIsMother(){
      if (!this.is_mother){
        router.push('/pishkhan')
      }

    }
  },
  mounted() {
    this.checkIsMother()
  }
}
</script>
<style scoped lang="scss">
a{
  font-size: 1vw;
}
.card:not(:last-child){
  height: 12vw;
}
.btn-submit-1{
  width: 18vw !important;
}
/*.line_after{
  position: relative;
  &::after{
    position: absolute;
    width: 0.01vw;
    height: 53vw;
    content: '';
    background-color: #efecf3 !important;
    top: 5vw;
    right: 35.3vw ;
    border-radius: 1vw;
  }
}*/
</style>